<template>
    <div>
        <div class="item-reconciliation-div-description">
            <b-row>
                <b-col sm="10">
                    <i class="fa-solid fa-sack-dollar"
                        :class="{ 'item-reconciliation-pay': item.type == 1, 'item-reconciliation-receive': item.type == 2 }"></i>
                    <span v-if="item.type == 1" class="item-reconciliation-pay title"> Pagar </span>
                    <span class="item-reconciliation-receive title" v-else> Receber </span>
                    <div class="side-by-side item-reconciliation-molded-description title" v-if="item.recipientName">
                        Destinatário: {{ item.recipientName }}
                    </div>
                    <div class="side-by-side item-reconciliation-molded-description title" v-if="item.description">
                        Descrição: {{ item.description }}
                    </div>
                    <div class="side-by-side item-reconciliation-molded-description title">
                        Vencimento: {{ item.dueDate }}
                    </div>
                    <div class="side-by-side item-reconciliation-molded-description title"
                        :class="{ 'item-reconciliation-pay': item.type == 1, 'item-reconciliation-receive': item.type == 2 }">
                        Valor: {{ item.value | currency }}
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col xs="12" :md="item.type == 1 ? 4 : 6" v-if="isNew">
                <Select title="Destinatário" field="recipient" :required="true" :showNewRegister="false"
                    url="api/v1/financial/payable-receivable/select-all-recipient" v-model="item.recipient">
                </Select>
            </b-col>
            <b-col xs="12" :md="item.type == 1 ? 4 : 6" v-if="isNew">
                <InputText title="Descrição" field="description" :required="true" :maxLength="200"
                    v-model="item.description" />
            </b-col>
            <b-col xs="12" md="4" v-if="item.type == 1 && isNew">
                <Select title="Locação Vinculada" field="type" :markFormDirty="false"
                    url="api/v1/rental/rent/select-all" v-model="item.rent" :showNewRegister="false">
                </Select>
            </b-col>
        </b-row>
        <b-row>
            <b-col xs="12" md="4">
                <Select title="Categoria" url="api/v1/financial/chart-of-accounts/select-all"
                    :propsParams="{ any: typeCostCenter }" :showNewRegister="false" :required="true"
                    v-model="item.chartOfAccounts">
                </Select>
            </b-col>
            <b-col xs="12" md="4">
                <Select title="Tipo de Pagamento" url="/api/v1/financial/type-payment/select-all" :showNewRegister="false"
                    :required="true" v-model="item.typePayment">
                </Select>
            </b-col>
            <b-col xs="12" md="4">
                <Select title="Conta Bancária" url="api/v1/financial/bank-account/select-all" :showNewRegister="false"
                    :required="true" :disabled="disabledBankAccount" v-model="item.bankAccount">
                </Select>
            </b-col>
        </b-row>
    </div>
</template>
<script>


import Select from "@/ui/forms/Select";
import InputText from "@/ui/forms/InputText";

import { costCenterType } from "../../mixins/reconciliationRecord.mixin.js";

export default {
    name: "ItemReconciliation",
    props: {
        item: Object,
        isNew: Boolean,
        disabledBankAccount: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Select, InputText
    },
    computed: {
        typeCostCenter() {
            return costCenterType(this.item.type);
        }
    },
}

</script>
<style scoped>
.item-reconciliation-molded-description {
    padding-left: 15px;
    padding-right: 15px;
    margin-right: 10px;
    margin-bottom: 10px;
    color: var(--text-primary);
}

.item-reconciliation-pay {
    color: var(--color-danger);
}

.item-reconciliation-receive {
    color: var(--color-success);
}

.item-reconciliation-div-description {
    margin-bottom: 15px;
}
</style>
